const autocompleteFormService = {
  places: 'Lugar',
  equipments: 'Equipo (primeros 50 resultados)',
  serviceType: 'Tipo do Servicio',
  latitude: 'Latitud',
  longitude: 'Longitud',
  noAuthorization: 'Sin Autorización',
};

export default autocompleteFormService;
